/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

/**
 * Selects the Page Builder pages usable as public record layouts.
 *
 * GET /arcee/application/<id>/pages/ responds with a BARE ARRAY —
 * `Response(PageListSerializer(pages, many=True).data)` — not a
 * `{ pages: [...] }` or DRF-paginated `{ results: [...] }` envelope. Reading
 * `.pages`/`.results` off it silently yields undefined and the caller sees an
 * empty list with no error anywhere, so the shape is normalised here in one
 * place rather than assumed at each call site.
 *
 * Only 'record_template' pages qualify. An ordinary page is reachable at
 * /<slug> and is not written against a record, so rendering one as a layout
 * would show raw {{ }} placeholders to visitors.
 */
export function pickRecordTemplatePages(pagesResponse) {
  const list = Array.isArray(pagesResponse)
    ? pagesResponse
    : (pagesResponse?.pages || pagesResponse?.results || []);

  return list.filter(p => p && p.page_type === 'record_template');
}
